import ApiConnector from "@/repository/connector";

class Tires {
  async getComplexes(tireId, secondTireId = null) {
    const result = {
      value: null,
      error: null,
    };
    const params = {
      first_tire_id: tireId,
    };
    if (secondTireId) {
      params.second_tire_id = secondTireId;
    }
    const response = await ApiConnector.connector.get(`/v1/tires/complexes/`, {
      params,
    });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getSizes({ size, params }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/tires/${size}/`, {
      params,
    });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Tires();
